<ng-container>
  <textarea
    [ngxSummernote]="config"
    [ngModel]="value"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="writeValue($event)"
    nz-col
    nzSpan="24"
    [disabled]="disabled"
    [ngxSummernoteDisabled]="disabled"
    (blur)="onFieldBlur($event)"
  ></textarea>
  <a
    nz-button
    [nzLoading]="aiLoading"
    style="margin-top: 10px"
    *ngIf="
      field.AdditionalData != null &&
      field.AdditionalData.useAiGeneration != null &&
      field.AdditionalData.useAiGeneration === true &&
      field.AdditionalData.aigenerationQuestion != null
    "
    class="ai-icon"
    (click)="aiLoading === false ? getAIText() : null"
  >
    <span>{{'Generate Text with AI'  | translate}}</span>
  </a>
</ng-container>
